export const getMaxCustomerApplications = (isLibertasUser: boolean) => {
  // Note: Leaving runway for this but this should be unnecessary with our
  // admin menu for Libertas users.
  if (isLibertasUser) {
    return 1;
  }

  return 1;
};
